import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  TextField,
  Toolbar,
  Tabs,
  Tab,
  Button,
  LinearProgress,
} from "@mui/material";
import { Visibility, Refresh, FilterList, Sort, Search, Add, Edit } from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';
import Layout from "../layout/layout";

const Clusters = () => {
  const theme = useTheme();
    
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  // Fixed S6479: Initialize attributes with a unique ID instead of just an index
  const [attributes, setAttributes] = useState([{ id: crypto.randomUUID(), key: '', value: '' }]);

  const clusters = [
    { id: 1, name: "default", details: { nodes: 2, groups: 1, storage: 3 } },
  ];

  const [hosts] = useState([]);

  const networks = [
    { id: 1, name: "Network 1", type: "bridge", used: 2, total: 50 },
  ];

  const datastores = [
    { id: 1, name: "files", type: "FILE", used: 5, total: 124, unit: "GB" },
    { id: 2, name: "default", type: "IMAGE", used: 5, total: 124, unit: "GB" },
    { id: 3, name: "system", type: "SYSTEM", used: 0, total: 0, unit: "KB" },
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleAddAttribute = () => {
    // Fixed S6479: Assign a unique ID to every new attribute added
    setAttributes([...attributes, { id: crypto.randomUUID(), key: '', value: '' }]);
  };

  const handleAttributeChange = (index, field, value) => {
    const newAttributes = [...attributes];
    newAttributes[index][field] = value;
    setAttributes(newAttributes);
  };

  return (
    <Layout pageType="sideBar">
      <Box sx={{ flex: 1, pl: 2, bgcolor: theme.palette.background.default, color: theme.palette.text.primary}}>
        <Toolbar sx={{ justifyContent: "space-between", bgcolor: "#grey", p: 0, borderRadius: 1 }}>
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <IconButton sx={{ color: "white" }}>
              <Refresh />
            </IconButton>
            <TextField
              variant="outlined"
              placeholder="Search..."
              sx={{
                bgcolor: "#43444f",
                color: "white",
                fontSize: theme.typography.body2,
                input: { color: "white" ,fontSize: theme.typography.body2},
                ml: 2,
                width: "300px",
                borderRadius: 1,
              }}
              slotProps={{
  htmlInput: { style: { fontSize: theme.typography.body2 } },}}
            />
          </Box>
          <Button variant="contained" sx={{ color: "white", bgcolor: "#00aaff" }}>
            Create Cluster
          </Button>
        </Toolbar>

        {selectedCluster ? (
          <Box sx={{ mt: 2 }}>
            <Tabs value={tabValue} onChange={handleTabChange} sx={{ color: '#fff' }}>
              <Tab label="Info" sx={{ color: "#fff" }}/>
              <Tab label="Host" sx={{ color: "#fff" }}/>
              <Tab label="Vnet" sx={{ color: "#fff" }}/>
              <Tab label="Datastore" sx={{ color: "#fff" }}/>
            </Tabs>
            <Box sx={{ p: 2, bgcolor: theme.palette.background.sideBg, borderRadius: 1, color: "#fff", fontSize:theme.typography.body2 }}>
              
              {tabValue === 0 && (
                 <Box sx={{ mt: 2, p: 2, border: '1px solid #444', borderRadius: 1 }}>
                   <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, borderBottom: "1px solid #444", pb: 2 }}>
                    <Box sx={{ flex: 1, mr: 2 }}>
                       <Typography variant="body2" sx={{ color: "#fff", pb: 1 ,mb:1,borderBottom:'1px solid grey',fontSize:theme.typography.body2 }}>
                         Information
                       </Typography>
                       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                         <Typography sx={{ color: "#fff",fontSize:theme.typography.body2 }}>ID</Typography>
                         <IconButton sx={{ color: "white" }}><Edit sx={{fontSize:theme.typography.body2 }}/></IconButton>
                       </Box>
                       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                         <Typography sx={{ color: "#fff",fontSize:theme.typography.body2 }}>Name</Typography>
                         <IconButton sx={{ color: "white" }}><Edit sx={{fontSize:theme.typography.body2 }}/></IconButton>
                       </Box>
                    </Box>
                    <Box sx={{ flex: 1, mr: 2 }}>
                       <Typography variant="body2" sx={{ color: "#fff", pb: 1 ,mb:1,borderBottom:'1px solid grey',fontSize:theme.typography.body2 }}>
                         Overcommitment
                       </Typography>
                       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                         <Typography sx={{ color: "#fff",fontSize:theme.typography.body2 }}>Allocated CPU</Typography>
                         <IconButton sx={{ color: "white" }}><Edit sx={{fontSize:theme.typography.body2 }}/></IconButton>
                       </Box>
                       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                         <Typography sx={{ color: "#fff",fontSize:theme.typography.body2 }}>Allocated Memory</Typography>
                         <IconButton sx={{ color: "white" }}><Edit sx={{fontSize:theme.typography.body2 }}/></IconButton>
                       </Box>
                    </Box>
                   </Box>
             
                   <Box sx={{ mt: 2 }}>
                     <Typography variant="body2" sx={{ color: "#fff", mb: 1 }}>Attributes</Typography>
                     {attributes.map((attribute, index) => (
                       // Fixed S6479: Using attribute.id as the key instead of array index
                       <Box key={attribute.id} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                         <TextField
                           variant="outlined"
                           placeholder="Key"
                           value={attribute.key}
                           onChange={(e) => handleAttributeChange(index, "key", e.target.value)}
                           sx={{ bgcolor: "#282e3a", color: "white", input: { color: "white",fontSize:theme.typography.body2 }, flex: 1, fontSize:theme.typography.body2 , mr: 1 }}
                         />
                         <TextField
                           variant="outlined"
                           placeholder="Value"
                           value={attribute.value}
                           onChange={(e) => handleAttributeChange(index, "value", e.target.value)}
                           sx={{ bgcolor: "#282e3a", color: "white", input: { color: "white",fontSize:theme.typography.body2 }, flex: 1, mr: 1 }}
                         />
                       </Box>
                     ))}
                     <IconButton onClick={handleAddAttribute} sx={{ color: "white" , fontSize:theme.typography.body2}}>
                       <Add sx={{fontSize:theme.typography.body2}}/>
                     </IconButton>
                   </Box>
                 </Box>
              )}

              {/* TAB 1: HOSTS */}
              {tabValue === 1 && (
                <Box>
                  <Toolbar sx={{ justifyContent: "space-between", bgcolor: theme.palette.background.sideBg, p: 2, borderRadius: 1, mb: 2 }}>
                    <TextField
                      variant="outlined"
                      placeholder="Search..."
                      sx={{ bgcolor: "#282e3a", color: "white", input: { color: "white" ,fontSize:theme.typography.body2 }, width: "300px", borderRadius: 1, ml: 1 }}
                      slotProps={{
  htmlInput: { startAdornment: <Search sx={{ color: "white", mr: 1 }} /> }, }}
                    />
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button variant="outlined" sx={{ color: "white", borderColor: "white",fontSize:theme.typography.body2 }} startIcon={<FilterList />}>Filter</Button>
                      <Button variant="outlined" sx={{ color: "white", borderColor: "white" ,fontSize:theme.typography.body2 }} startIcon={<Sort />}>Sort</Button>
                    </Box>
                  </Toolbar>

                  {hosts.length > 0 ? (
                    hosts.map((host) => (
                      <Paper key={host.id} sx={{ p: 2, mt: 2, bgcolor: theme.palette.background.sideBg, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                            <Box sx={{ width: 10, height: 10, bgcolor: "green", borderRadius: "50%" }} />
                            <Typography sx={{ color: "white" ,fontSize:theme.typography.body2 }}>{host.ip}</Typography>
                          </Box>
                        </Box>
                      </Paper>
                    ))
                  ) : (
                    <Typography sx={{ color: "white", textAlign: 'center', mt: 4, fontSize: theme.typography.body2 }}>
                      No hosts found in this cluster.
                    </Typography>
                  )}
                </Box>
              )}

              {/* TAB 2: NETWORKS */}
              {tabValue === 2 && (
                 <Box>
                   {networks.map((network) => {
                     const percent = network.total > 0 ? (network.used / network.total) * 100 : 0;
                     return (
                       <Paper key={network.id} sx={{ p: 2, mt: 2, bgcolor: "#282e3a", borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                         <Typography sx={{ color: "white",fontSize:theme.typography.body2 }}>{network.name}</Typography>
                         <Box sx={{ display: "flex", alignItems: "center", width: '30%' }}>
                           <LinearProgress variant="determinate" value={percent} sx={{ flex: 1, height: 3, bgcolor: '#282e3a' }} />
                           <Typography sx={{ color: "white", ml: 2,fontSize:theme.typography.body2 }}>{percent.toFixed(1)}%</Typography>
                         </Box>
                       </Paper>
                     )
                   })}
                 </Box>
              )}

              {/* TAB 3: DATASTORES */}
              {tabValue === 3 && (
                <Box>
                {datastores.map((datastore) => {
                  const percent = datastore.total > 0 ? (datastore.used / datastore.total) * 100 : 0;
                  return (
                    <Paper key={datastore.id} sx={{ p: 2, mt: 2, bgcolor: "#282e3a", borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <Typography sx={{ color: "white",fontSize:theme.typography.body2 }}>{datastore.name}</Typography>
                      <Box sx={{ display: "flex", alignItems: "center", width: '30%' }}>
                        <LinearProgress variant="determinate" value={percent} sx={{ flex: 1, height: 3, bgcolor: '#282e3a' }} />
                        <Typography sx={{ color: "white", ml: 2 ,fontSize:theme.typography.body2 }}>{percent.toFixed(1)}%</Typography>
                      </Box>
                    </Paper>
                  )
                })}
              </Box>
              )}
            </Box>
            <Button onClick={() => setSelectedCluster(null)} sx={{ mt: 2, color: "white" }}>
              Back to Clusters
            </Button>
          </Box>
        ) : (
          clusters.map((cluster) => (
            <Paper key={cluster.id} sx={{ p: 1, mt: 1, bgcolor: "#282e3a", borderRadius: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography sx={{ color: "white", fontSize:theme.typography.body2}}>{cluster.name}</Typography>
                <IconButton onClick={() => setSelectedCluster(cluster)} sx={{ color: "white" }}>
                  <Visibility />
                </IconButton>
              </Box>
            </Paper>
          ))
        )}
      </Box>
    </Layout>
  );
};

export default Clusters;